var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 24.5a9.41 9.41 0 1118.818 0",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.41 13a5.75 5.75 0 10-.001-11.5 5.75 5.75 0 000 11.5z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zIDI0LjVDMyAxOS4zMDM1IDcuMjEyNTkgMTUuMDkwOSAxMi40MDkxIDE1LjA5MDlDMTcuNjA1NiAxNS4wOTA5IDIxLjgxODIgMTkuMzAzNSAyMS44MTgyIDI0LjUiIHN0cm9rZT0iY3VycmVudCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjQwOTEgMTNDMTUuNTg0NyAxMyAxOC4xNTkxIDEwLjQyNTYgMTguMTU5MSA3LjI1QzE4LjE1OTEgNC4wNzQzNiAxNS41ODQ3IDEuNSAxMi40MDkxIDEuNUM5LjIzMzQ1IDEuNSA2LjY1OTA5IDQuMDc0MzYgNi42NTkwOSA3LjI1QzYuNjU5MDkgMTAuNDI1NiA5LjIzMzQ1IDEzIDEyLjQwOTEgMTNaIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgUser as ReactComponent };